(() => {
 const setup = () => {
  document.querySelectorAll('.ks-catalog-head').forEach(head => {
   if(head.dataset.catalogReady)return;
   const product=head.querySelector('ks-product');
   if(!product?.data)return;
   head.dataset.catalogReady='true';
   const options=head.querySelector('[data-ks-choice-options]');
   if(options){
    const variants=JSON.parse(options.querySelector('[data-ks-choice-data]').textContent);
    const axes=[...options.querySelectorAll('[data-ks-axis]')];
    const sync=()=>{
     const current=variants.find(v=>String(v.id)===product.input.value);if(!current)return;
     axes.forEach((axis,i)=>{
      axis.querySelector('[data-ks-selected-value]').textContent=current.options[i];
      axis.querySelectorAll('[data-ks-choice]').forEach(button=>{
       const value=button.dataset.ksChoice;
       button.setAttribute('aria-pressed',String(current.options[i]===value));
       const matches=variants.filter(v=>v.options[i]===value);
       // Color/model changes may select a matching size; size availability is specific to the chosen color.
       const compatible=i===0?matches:matches.filter(v=>v.options.every((option,j)=>j===i||option===current.options[j]));
       button.classList.toggle('is-sold-out',!compatible.some(v=>v.available));
       button.disabled=!matches.length;
      });
     });
    };
    options.addEventListener('click',event=>{
     const button=event.target.closest('[data-ks-choice]');if(!button)return;
     const index=Number(button.closest('[data-ks-axis]').dataset.ksAxis);
     const current=variants.find(v=>String(v.id)===product.input.value);
     const desired=current.options.map((v,i)=>i===index?button.dataset.ksChoice:v);
     const exact=variants.find(v=>v.options.every((value,i)=>value===desired[i]));
     const matches=variants.filter(v=>v.options[index]===desired[index]);
     const selected=exact||matches.find(v=>v.available)||matches[0];
     if(selected)product.selectVariant(selected.id,true);
    });
    product.addEventListener('variant:change',sync);sync();
   }
   const chart=head.querySelector('[data-ks-chart]');
   head.querySelector('[data-ks-chart-open]')?.addEventListener('click',()=>chart.showModal());
   head.querySelector('[data-ks-chart-close]')?.addEventListener('click',()=>chart.close());
   chart?.addEventListener('click',event=>{if(event.target===chart){const r=chart.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)chart.close();}});
  });
  document.querySelectorAll('.ks-apparel-description table').forEach(table=>{
   if(table.parentElement.classList.contains('ks-apparel-table-scroll'))return;
   const wrap=document.createElement('div');wrap.className='ks-apparel-table-scroll';table.before(wrap);wrap.append(table);
  });
 };
 customElements.whenDefined('ks-product').then(()=>{
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',setup);else setup();
 });
 document.addEventListener('shopify:section:load',setup);
})();
